import { DateTime } from 'luxon';

export const formatDate = (isoDate) => {
  if (!isoDate || isoDate === '0001-01-01T00:00:00') return 'Nunca';

  try {
    // A data vem do backend em UTC (mesmo sem o sufixo "Z").
    // Interpretamos como UTC e convertemos para o fuso horário do cliente.
    return DateTime.fromISO(isoDate, { zone: 'utc' })
      .toLocal()
      .toFormat('dd/MM/yyyy HH:mm');
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return 'Nunca';
  }
};
export const formatDuration = (duration) => {
  if (!duration) return "0min00s";

  let totalSeconds = 0;

  // Caso 1 → já for número (segundos ou milissegundos)
  if (typeof duration === "number") {
    // se for maior que horas em segundos pode ser ms → normaliza
    totalSeconds = duration > 100000 ? Math.floor(duration / 1000) : Math.floor(duration);
  } 
  // Caso 2 → for string tipo "00:02:09.5606000"
  else if (typeof duration === "string") {
    const parts = duration.split(":");
    if (parts.length >= 3) {
      const [hours, minutes, seconds] = parts;
      totalSeconds =
        (+hours * 3600) +
        (+minutes * 60) +
        Math.floor(parseFloat(seconds));
    } else {
      // se por acaso vier "129.56" em string → tenta converter direto
      totalSeconds = Math.floor(parseFloat(duration));
    }
  }

  // Formatação
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;

  return `${mins}min${String(secs).padStart(2, "0")}s`;
};



// Função para formatar última sincronização de forma relativa
export const formatLastSync = (date) => {
  if (!date) return 'Nunca';
  
  try {
    // A data vem do backend em UTC (mesmo sem o sufixo "Z").
    const syncDate = DateTime.fromISO(date, { zone: 'utc' });
    const diffMs = DateTime.utc().toMillis() - syncDate.toMillis();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) {
      return `Há ${diffMins} minutos`;
    } else if (diffHours < 24) {
      return `Há ${diffHours} horas`;
    } else if (diffDays < 7) {
      return `Há ${diffDays} dias`;
    } else {
      // Converte para o fuso horário do cliente para exibição.
      return syncDate.toLocal().toFormat('dd/MM/yyyy HH:mm');
    }
  } catch (error) {
    console.error('Erro ao formatar data de sincronização:', error);
    return 'Nunca';
  }
};